
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/AboutUs",
      function () {
        return require("private-next-pages/AboutUs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/AboutUs"])
      });
    }
  